// stub: package referenced in package.json but not actually imported by smart-use-case code paths
module.exports = new Proxy(function () {}, {
    get: function (_t, prop) {
        if (prop === '__esModule') return true;
        if (prop === 'default') return module.exports;
        return module.exports;
    },
    apply: function () { return module.exports; },
    construct: function () { return module.exports; }
});
